function getValueOrCleanNull(value, fieldObj) {
  let result = value;

  if (value === "") {
    if (!fieldObj.nullValueReplacement && fieldObj.nullValueReplacement !== "") result = null
    else result = ""
    //logger.info("value empty. set it to '" + result + "'. nvr is '" + fieldObj.nullValueReplacement + "'")
  }
  return result
}

/*
function htmlUnescape(str) {
  if (str && typeof str === 'string') {
    str = str.replaceAll("&amp;", "&");
    str = str.replaceAll("&auml;", "ä");
    str = str.replaceAll("&uuml;", "ü");
    str = str.replaceAll("&ouml;", "ö");
    str = str.replaceAll("&Auml;", "Ä");
    str = str.replaceAll("&Uuml;", "Ü");
    str = str.replaceAll("&Ouml;", "Ö");
    str = str.replaceAll("&szlig;", "ß");
    str = str.replaceAll("&lt;", "<");
    str = str.replaceAll("&gt;", ">");
    str = str.replaceAll("&sup2;", "²");
    str = str.replaceAll("&sup3;", "³");
  }
  return str;
}
*/

function cleanHTML(html) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export {getValueOrCleanNull, cleanHTML}
